import React, { useState, useEffect } from "react";


import * as Constants from '../../utils/constants';
import { validateEmptyString } from '../../utils/validation';

import Select from 'react-select';


import '../../assets/css/form.css';


function AddSection() {
    const [sectionCode, setSectionCode] = useState("");
    const [sectionDescription, setSectionDescription] = useState("");
    const [categorySessionId, setCategorySessionId] = useState("");

    const [categoryOptions, setCategoryOptions] = useState([]);
    const [categorySelectedOptions, setCategorySelectedOptions] = useState([]);

    const [sessionOptions, setSessionOptions] = useState([]);
    const [sessionSelectedOptions, setSessionSelectedOptions] = useState([]);


    const [isSubmitting, setIsSubmitting] = useState(false);

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);



    const handleCategorySelectChange = categorySelectedOptions => {
        setCategorySelectedOptions(categorySelectedOptions);
        console.log(categorySelectedOptions.value)

    };

    const handleSessionSelectChange = sessionSelectedOptions => {
        setSessionSelectedOptions(sessionSelectedOptions);
        console.log(categorySelectedOptions.value)

    };

    const checkIfCategorySessionAlreadyExists = async (categoryID, sessinId) => {

        try {

            const categorySessionFilter = { "session": { "_eq": sessinId }, "category": { "_eq": categoryID } }

            const fetchCategorySession = Constants.API_ENDPOINT + Constants.ENDPOINT_CATEGORY_SESSION + '?filter=' + JSON.stringify(categorySessionFilter)

            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Constants.TOKEN}`

            }

            const categorySessionCheckResponse = await fetch(fetchCategorySession, {
                headers: headers
            });

            if (categorySessionCheckResponse.ok) {
                const data = await categorySessionCheckResponse.json();
                console.log("Data:", data.data)
                if (data.data.length == 0) {

                } else {
                    setCategorySessionId("here")

                }

            } else {
                setError(Constants.SOMETHING_WENT_WRONG);
                setIsSubmitting(false);
            }
        }
        catch (error) {
            console.error(error)
            setError(Constants.SOMETHING_WENT_WRONG);
        }



    }



    const handleFormSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        setError("");
        setSuccess("")

        try {

            const errors = [];


            // if (!validateEmptyString(sectionCode)) {
            //     errors.push(Constants.VALID_SECTION_CODE_ERROR);
            // }
            // else if (!validateEmptyString(sectionDescription)) {
            //     errors.push(Constants.VALID_SECTION_DESCRIPTION_ERROR);
            // }
            // else if (!validateEmptyString(categorySelectedOptions.value)) {
            //     errors.push(Constants.VALID_CATEGORY_SELECT_ERROR);
            // }
            // else if (!validateEmptyString(categorySelectedOptions.value)) {
            //     errors.push(Constants.VALID_SESSION_SELECT_ERROR);
            // }


            if (errors.length > 0) {
                setError(errors);
                setIsSubmitting(false);
            } else {
                // submit form data
                console.log("Category Id: ", categorySelectedOptions.value)
                console.log("Session Id: ", sessionSelectedOptions.value)

                var addSectionURL = Constants.API_ENDPOINT + Constants.ENDPOINT_ITEMS_SECTION
                var post_request = JSON.stringify(
                    {
                        'status': Constants.PUBLISHED,
                        'section_code': sectionCode,
                        'section_desc': sectionDescription,
                        'category_session': categorySessionId
                    })
                console.log(post_request)

                console.log("Can Add Section ")
                checkIfCategorySessionAlreadyExists(categorySelectedOptions.value, sessionSelectedOptions.value)
                return

                const response = await fetch(addSectionURL, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Constants.TOKEN}`

                    },
                    body: post_request,
                });

                if (response.ok) {
                    const data = await response.json();
                    console.log(data)
                    setIsSubmitting(false);
                    setSuccess(Constants.SUCCESSFULLY_ADDED)
                    setSectionCode('');
                    setSectionDescription('')
                    setCategorySessionId('');
                } else {
                    setError(Constants.SOMETHING_WENT_WRONG);
                    setIsSubmitting(false);
                }
            }
        } catch (error) {
            console.error(error);
            setIsSubmitting(true);
            setError(Constants.SOMETHING_WENT_WRONG);
        }
    };


    useEffect(() => {
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${Constants.TOKEN}`);


        //Start Section Select Options
        var categoryListUrl = Constants.API_ENDPOINT + Constants.ENDPOINT_ITEMS_CATEGORY
        var fetchCategoryOptions = async () => {
            try {
                const response = await fetch(categoryListUrl, { headers });
                const data = await response.json();
                setCategoryOptions(data.data);
            }
            catch (error) {
                console.log(error);
            }
        };

        var sessionListUrl = Constants.API_ENDPOINT + Constants.ENDPOINT_ITEMS_SESSION + '?filter=' + JSON.stringify(Constants.STATUS_PUBLISHED_JSON_OBJECT)

        const fetchSessionOptions = async () => {
            const response = await fetch(sessionListUrl, { headers });
            const data = await response.json();
            setSessionOptions(data.data);
        };



        fetchCategoryOptions();
        fetchSessionOptions()

        //End Section Select Options
    }, []);


    return (
        <div>
            <h2>Add Section</h2>

            <form className="form-container" onSubmit={handleFormSubmit}>
                <div className="form-group">
                    <label>
                        Section Code
                        <input type="text" value={sectionCode} onChange={(e) => setSectionCode(e.target.value)} />
                    </label>
                </div>

                <div className="form-group">
                    <label>
                        Section Description
                        <input type="text" value={sectionDescription} onChange={(e) => setSectionDescription(e.target.value)} />
                    </label>
                </div>

                {/* <div className="form-group">
                    <Select placeholder="Category" value={categorySelectedOptions} options={categoryOptions.map(item => ({ label: item.category_name, value: item.category_id }))} onChange={handleCategorySelectChange} />

                </div>

                <div className="form-group">
                    <Select placeholder="Session" value={sessionSelectedOptions} options={sessionOptions.map(item => ({ label: item.session_name, value: item.session_id }))} onChange={handleSessionSelectChange} />


                </div> */}










                <div className="form-group">

                    <button type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Please wait...' : 'Add'}
                    </button>

                </div>
                {isSubmitting && <div className="spinner"></div>}


                {error && <p className="error-message ">{error}</p>}
                {success && <p className="success-message ">{success}</p>}


            </form>
        </div>
    );
}

export default AddSection;
